<template>
  <div>
    <v-container>
      <v-row>
        <v-col>
          <h2>{{ $t("data-export-validation.file-status") }}</h2>
          <FeedbackTable :items="feedback"></FeedbackTable>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>
<script>
import FeedbackTable from "../../../../common/feedback/FeedbackTable.vue";
export default {
  name: "UnknownTypeValidation",
  components: { FeedbackTable },
  props: {
    content: {
      type: Object,
      default: function() {
        return {};
      }
    },
    feedback: {
      type: Array,
      default: function() {
        return [];
      }
    }
  }
};
</script>
